import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { DefaultLayoutHeader } from '~/components/layouts/DefaultLayout/Header';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { PortalList } from '~/features/PortalList';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  return (
    <div className={styles.Screen}>
      <ClientSideMenu />
      <div className={styles.ContentWrapper}>
        <DefaultLayoutHeader title='ポータル' />
        <div className={styles.Content}>
          <Suspense fallback={<Loader />}>
            <PortalList />
          </Suspense>
        </div>
      </div>
    </div>
  );
};
